import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MassOsB2bClient } from 'src/entities/file';

@Component({
  selector: 'app-mass-os-client',
  templateUrl: './mass-os-client.component.html',
  styleUrls: ['./mass-os-client.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MassOsClientComponent {
  @Input() b2bClientIds: string[] = [];
  @Input() b2bClients: MassOsB2bClient[] = [];
  @Input() submitted = false;
  @Input() isLoadingClients = false;

  @Output() formChange = new EventEmitter<{ b2bClientIds?: string[] }>();

  b2bSearch = '';

  trackByOption = (_index: number, option: { id: string }): string =>
    option.id;

  get filteredB2bClients(): MassOsB2bClient[] {
    const term = this.b2bSearch.trim().toLowerCase();
    if (!term) {
      return this.b2bClients;
    }
    return this.b2bClients.filter((client) =>
      client.name.toLowerCase().includes(term)
    );
  }

  get selectedB2bClients(): MassOsB2bClient[] {
    return this.b2bClients.filter((client) =>
      this.b2bClientIds.includes(client.id)
    );
  }

  get allVisibleB2bSelected(): boolean {
    const visible = this.filteredB2bClients;
    return (
      visible.length > 0 &&
      visible.every((client) => this.b2bClientIds.includes(client.id))
    );
  }

  get someVisibleB2bSelected(): boolean {
    const visible = this.filteredB2bClients;
    const count = visible.filter((client) =>
      this.b2bClientIds.includes(client.id)
    ).length;
    return count > 0 && count < visible.length;
  }

  get b2bError(): string | null {
    return this.submitted && !this.b2bClientIds.length
      ? 'Seleccionar uno o varios clientes es requerido.'
      : null;
  }

  onB2bSearchChange(value: string): void {
    this.b2bSearch = value ?? '';
  }

  onToggleAllVisibleB2b(checked: boolean): void {
    const visibleIds = new Set(
      this.filteredB2bClients.map((client) => client.id)
    );

    const nextIds = checked
      ? this.b2bClients
          .map((client) => client.id)
          .filter((id) => visibleIds.has(id) || this.b2bClientIds.includes(id))
      : this.b2bClientIds.filter((id) => !visibleIds.has(id));

    this.formChange.emit({ b2bClientIds: nextIds });
  }

  onToggleB2b(id: string, checked: boolean): void {
    const b2bClientIds = checked
      ? [...this.b2bClientIds, id]
      : this.b2bClientIds.filter((value) => value !== id);
    this.formChange.emit({ b2bClientIds });
  }
}
